import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FieldArray, reduxForm, formValueSelector } from 'redux-form';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import cx from 'classnames';
import { Button } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl, FormattedMessage } from 'react-intl';

import ImageUploadComponent from '../ImageUploadComponent/ImageUploadComponent';
import CommonImageDisplay from '../CommonImageDisplay/CommomImageDisplay';
import FieldArrayComponent from '../../CommonFields/FieldArrayComponent';

import submit from './submit';
import validate from './validate';
import { photosShow } from '../../../helpers/photosShow';
import { startBannerUploaderLoader, stopBannerUploaderLoader, doUploadHomeBanner } from '../../../actions/siteadmin/manageHomepageBanner';
import { homebanneruploadDir } from '../../../config';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';
import { formatLocaleData } from '../../../helpers/formatLocale';

import cp from '../../../components/commonStyle.css';
import s from './BannerSettingsForm.css';
import messages from '../../../locale/jsonMessages';
class BannerSettingsForm extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    title: PropTypes.string.isRequired,
    startBannerUploaderLoader: PropTypes.any.isRequired,
    doUploadImageBanner: PropTypes.any.isRequired
  };

  success = async (file, fromServer) => {
    const { doUploadHomeBanner, image, id, startBannerUploaderLoader, stopBannerUploaderLoader, demoRestriction } = this.props;
    let fileName = fromServer.file.filename;
    let oldImage = image || null;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    startBannerUploaderLoader();
    doUploadHomeBanner(fileName, oldImage, id);
    stopBannerUploaderLoader();
  }

  render() {

    const { error, handleSubmit, submitting, bannerUploaderLoading, image, selectedLanguage } = this.props;
    const { formatMessage } = this.props.intl;
    let path = photosShow(homebanneruploadDir);

    return (
      <div className='siteAdminCenterContainer siteAdminCenterContainerBox'>
        <h1 className='siteAdminHeading'><FormattedMessage  {...messages.bannerCaptionLabel} /></h1>
        <form onSubmit={handleSubmit(submit)}>
          {/* {error && <strong>{formatMessage(error)}</strong>} */}
          <div className="oneColumnGrid">
            <div>
              <label className={cx('commonLabelText', cp.spaceBottom3)}><FormattedMessage  {...messages.homeBannerImage} /></label>
              <ImageUploadComponent
                defaultMessage={formatMessage(messages.photosPlaceholder)}
                componentConfig={{
                  iconFiletypes: ['.jpg', '.png', '.jpeg'],
                  multiple: false,
                  showFiletypeIcon: false,
                  postUrl: '/uploadHomeBanner'
                }}
                loaderName={'bannerUploaderLoading'}
                success={this.success}
                imageBanner
              />
              {
                image != null &&
                <CommonImageDisplay
                  loader={bannerUploaderLoading}
                  image={image && path + image}
                  imageBanner
                />
              }
            </div>
            <FieldArray
              name="dynamicBanner"
              component={FieldArrayComponent}
              activesFields={['language', 'title', 'content']}
              filedName={"dynamicBanner"}
              selectedLanguage={selectedLanguage}
            />
          </div>
          <div className={cx(cp.spaceTop4, 'singleBtnFlexEnd')}>
            <Button className={cx(cp.btnPrimary)} type="submit" disabled={submitting} >
              <FormattedMessage  {...messages.save} />
            </Button>
          </div>
        </form>
      </div>
    );
  }

}

BannerSettingsForm = reduxForm({
  form: 'BannerSettingsForm',
  validate
})(BannerSettingsForm);

const selector = formValueSelector('BannerSettingsForm');

const mapState = (state) => ({
  bannerUploaderLoading: state.loader.bannerUploaderLoading,
  selectedLanguage: selector(state, 'dynamicBanner'),
  activeLanguageCodes: state.runtime.isActiveLanguages.map(item => formatLocaleData(item))
});

const mapDispatch = {
  doUploadHomeBanner,
  startBannerUploaderLoader,
  stopBannerUploaderLoader,
  demoRestriction
};

export default compose(
  injectIntl,
  withStyles(cp, s),
  connect(mapState, mapDispatch)
)(BannerSettingsForm);
